import styled from "styled-components";
import { Modal, NewSelect } from "@bca/ui-library";
import theme from "../../styles/theme";

export const StyledModal = styled(Modal)`
  width: ${(props) => (props.isMobile ? "22.188rem" : "31.875rem")};
  min-height: 22.75rem;
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ModalTitle = styled.div`
  margin-top: 0.5rem;
  font-weight: 700;
  font-size: 1.25rem;
`;

export const ModalSubtitle = styled.div`
  font-weight: 400;
  font-size: 0.938rem;
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
  color: ${theme.color.text};
`;

export const StyledNewSelect = styled(NewSelect)`
  display: flex;
  flex: auto;
  min-width: ${(props) => (props.isMobile ? "19.688rem" : "28.125rem")};
  margin-bottom: 4rem;
`;
